<template>
  <div>
    <h1 class="subtitle">Marcas</h1>
    <hr />
    <div class="columns">
      <div class="column is-9">
        <button class="button is-success" @click="prompt">
          <b-icon icon="plus" size="is-small"></b-icon> <span>Agregar</span>
        </button>
      </div>
      <div class="column is-3">
        <input
          type="text"
          class="input is-pulled-right"
          @keyup="searchData"
          placeholder="Buscar"
          v-model="search"
        />
      </div>
    </div>
    <b-table
      :data="data"
      :loading="loading"
      paginated
      bordered
      backend-pagination
      :total="total"
      :per-page="perPage"
      aria-next-label="Siguiente"
      aria-previous-label="Anterior"
      aria-page-label="Pág."
      aria-current-label="Pág. actual"
      @page-change="onPageChange"
    >
      <template slot-scope="props">
        <b-table-column field="descripcion" label="Marca" header-class="is-info">
          {{ props.row.descripcion }}
        </b-table-column>
        <b-table-column label="" header-class="is-info">
          <a href="#" @click.prevent="deleteRow(props.row)" title="Eliminar"
            ><span class="icon has-text-danger">
              <i class="mdi mdi-delete mdi-18px"></i> </span
          ></a>
        </b-table-column>
      </template>
      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>No se encontraron Marcas</p>
          </div>
        </section>
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "MarcaList",
  data() {
    return {
      loading: false,
      data: [],
      perPage: 10,
      total: 0,
      page: 1,
      search: "",
      timer: null
    };
  },
  methods: {
    deleteRow(row) {
      this.$buefy.dialog.confirm({
        message: "Esta seguro de eliminar la marca",
        onConfirm: () => {
          axios
            .delete("/marca/delete", { data: { id_marca: row.id_marca } })
            .then(
              () => {
                this.$buefy.toast.open({
                  message: `Se elimino la marca ${row.descripcion}`,
                  type: "is-success"
                });
                this.loadDataTable();
              },
              () => {
                this.$buefy.toast.open({
                  message: `Ocurrio un problema al eliminar la marca`,
                  type: "is-danger"
                });
              }
            );
        }
      });
    },
    loadDataTable() {
      let _self = this;
      _self.loading = true;
      axios
        .post("/marca/list", {
          search: this.search,
          length: this.perPage,
          start: (this.page - 1) * this.perPage
        })
        .then(
          response => {
            _self.data = response.data.data;
            _self.total = response.data.total;
            _self.loading = false;
          },
          () => {
            _self.loading = false;
          }
        );
    },
    onPageChange(page) {
      this.page = page;
      this.loadDataTable();
    },
    searchData() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      let _self = this;
      this.timer = setTimeout(() => _self.loadDataTable(), 1000);
    },
    prompt() {
      this.$buefy.dialog.prompt({
        message: `Ingrese Nueva Marca:`,
        inputAttrs: {
          placeholder: "Marca",
          maxlength: 100
        },
        trapFocus: true,
        onConfirm: value => {
          axios.post("/marca/new", { marca: value }).then(
            response => {
              this.$buefy.toast.open({
                message: `Se agrego la marca ${response.data.descripcion}`,
                type: "is-success"
              });
              this.loadDataTable();
            },
            err => {
              this.$buefy.toast.open({
                message: err.response.data.message,
                type: "is-danger"
              });
            }
          );
        }
      });
    }
  },
  mounted() {
    this.loadDataTable();
  }
};
</script>

<style scoped></style>
